import { apiClient } from './client';
import { wpUploadImage } from './wordpress';
import type { ApiResponse } from '@/types/api';
import type { ProfileDTO, UpdateProfileRequest } from '@/types/profile';

export const profileApi = {
  getProfile() {
    return apiClient.get<ApiResponse<ProfileDTO>>('/api/account/profile');
  },

  getPublicProfile() {
    return apiClient.get<ApiResponse<ProfileDTO>>('/api/public/profile');
  },

  updateProfile(data: UpdateProfileRequest) {
    return apiClient.put<ApiResponse<ProfileDTO>>('/api/account/profile', data);
  },

  async uploadAvatar(file: File): Promise<string> {
    const imageUrl = await wpUploadImage(file);
    // Save the WordPress URL back to the backend profile
    await apiClient.post<ApiResponse<{ imageUrl: string }>>(
      '/api/account/profile/avatar-url',
      { imageUrl },
    );
    return imageUrl;
  },

  async setAvatarUrl(imageUrl: string): Promise<string> {
    await apiClient.post<ApiResponse<{ imageUrl: string }>>(
      '/api/account/profile/avatar-url',
      { imageUrl },
    );
    return imageUrl;
  },
};
